// ProfileContext.js
import React, { createContext, useState, useContext } from "react";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profilePic, setProfilePic] = useState("default-avatar.png"); // Initial default image

  const updateProfilePic = (newPic) => {
    setProfilePic(newPic);
  };

  return (
    <ProfileContext.Provider value={{ profilePic, updateProfilePic }}>
      {children}
    </ProfileContext.Provider>
  );
};

// Custom hook for easy consumption
export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error("useProfile must be used within ProfileProvider");
  }
  return context;
};
